var _defs, _text, _text2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBizdeployLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 100,
    viewBox: "0 0 320 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#bbe1fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3498db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#65c6f7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "over"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 58,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 48,
    textAnchor: "middle",
    fill: "url(#logoGradient)",
    filter: "url(#glow)"
  }, "BizDeploy")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 85,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontWeight: 600,
    fontSize: 20,
    fill: "url(#logoGradient)"
  }, "CUSTOM WEBSITES")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,90 L300,90",
    stroke: "url(#accentGradient)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 90,
    r: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 90,
    r: 3,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#accentGradient)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 58,
    fontFamily: "monospace",
    fontWeight: "bold",
    fontSize: 48
  }, "{"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 58,
    textAnchor: "end",
    fontFamily: "monospace",
    fontWeight: "bold",
    fontSize: 48
  }, "}"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizdeployLogo);
export default __webpack_public_path__ + "static/media/bizdeploy-logo.957cfb8847e001326016840c48fff8cb.svg";
export { ForwardRef as ReactComponent };